import UserChatRoom from './UserChatRoom';

export default UserChatRoom;

